module.exports = __webpack_public_path__ + "img/image_slide5_4.6bcc64fd.png";